import { render, staticRenderFns } from "./CommentPdfText.vue?vue&type=template&id=8a9b3d20&"
import script from "./CommentPdfText.vue?vue&type=script&lang=js&"
export * from "./CommentPdfText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports